import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    talla: [],
  },

  getters: {
    getTalla: (state) => state.talla,
  },

  mutations: {
    SET_TALLA(state, talla) {
      state.talla = talla;
    },
  },

  actions: {
    async fetchTalla({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catTalla')
        .then((response) => {
          commit('SET_TALLA', response.data.data);
        });
    },
  },
};
